// extracted by mini-css-extract-plugin
module.exports = {"center":"NbHits_center__2pHkt","mobileText":"NbHits_mobileText__1Qe3I","spinAround":"NbHits_spinAround__1ieNQ"};